import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';

import {twoDecimalPlaceRounder} from 'services/UtilityService';

const ProjectedSavings = ({ paid, projected, savings, hideSavings }) => {
  const projectedDisplay = hideSavings ? 'N/A' : `$ ${twoDecimalPlaceRounder(projected)}`;
  const savingsDisplay = hideSavings ? 'N/A' : `$ ${twoDecimalPlaceRounder(savings)}`;
  const savingsBadgeClassName = hideSavings
    ? 'bg-secondary'
    : (savings > 0 ? 'badge-success bg-secondary' : 'badge-danger');

  return (
    <div>
      <div className='small-label'>
        Savings
      </div>
      <Container fluid style={{ paddingTop: 10 }}>
        <Row>
          <Col md={6} className="rm-horizontal-center">
            <div>
              <div className='rm-tiny-top-label'>Paid</div>
              <div>$ {twoDecimalPlaceRounder(paid)}</div>
            </div>
          </Col>
          <Col md={6} className="rm-horizontal-center">
            <div>
              <div className='rm-tiny-top-label'>Projected</div>
              <div>{projectedDisplay}</div>
            </div>
          </Col>
        </Row>
        <Row className="tiny-top-spacer">
          <Col md={12} className="rm-horizontal-center">
            <div>
              <div className='rm-tiny-top-label' style={{ marginBottom: 5 }}>Savings</div>
              <Badge className={savingsBadgeClassName} style={{ fontSize: "inherit" }}>
                {savingsDisplay}
              </Badge>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectedSavings;